import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';
import { DocLinks, MafStatusQueue } from 'types/Api';

const getDemoProject = () => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.GetStarted_Project,
      },
    ],
  });
};

const getDocLinks = (): Promise<DocLinks> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.GetStarted_LandingData,
      },
    ],
  });
};

const confirmInvite = (code: string): Promise<void> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Onboarding_DemoStageInvitation,
        payload: { code },
      },
    ],
  });
};

const contactSales = (params: {
  type: string;
  message?: string;
}): Promise<MafStatusQueue> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Onboarding_ContactSales,
        payload: params,
      },
    ],
    showValidateNotification: false,
  });
};

export default {
  getDemoProject,
  confirmInvite,
  getDocLinks,
  contactSales,
};
